import { FC } from "react";

interface ClosingCrossDarkGreySVGProps {
    className?: string;
    onClick?: () => void;
}

const ClosingCrossDarkGreySVG: FC<ClosingCrossDarkGreySVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            onClick={props.onClick}
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="22" height="22" rx="11" fill="#4B4B52" />
            <path d="M6 6L16 16" stroke="#7A7A7E" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 6L6 16" stroke="#7A7A7E" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default ClosingCrossDarkGreySVG;
